<template>
  <v-container bg="db" id="price" class="price">
    <v-headline :level="2" class="price-headline">
      <div class="uppercase">{{ dic.sectionPrice.title1 }}</div>
    </v-headline>
    <p class="price-subheadline text-md">
      {{ dic.sectionPrice.msg1 }}
    </p>
    <!-- <v-slider /> -->

    <div v-show="isForm" id="price-form" class="price-form">
      <BitrixPriceForm />
    </div>
    <v-button
      v-show="!isForm"
      class="price-button"
      :color="'Y'"
      type="R"
      @click.native="handleClick"
    >
      <v-link
        :anchor="'#price'"
        class="button text-sm text-md"
        :label="'заказать' | capitalize"
      >
        {{ dic.findOutTheCost }}
      </v-link>
    </v-button>
  </v-container>
</template>

<script>
import VHeadline from '@/components/ui/VHeadline'
import VContainer from '@/components/ui/VContainer'
// import VSlider from '@/components/ui/VSlider'
import VLink from '@/components/ui/VLink'
import VButton from '@/components/ui/VButton'
import { mapMutations } from 'vuex'
import BitrixPriceForm from '@/components/bitrix/BitrixPriceForm'

export default {
  name: 'SectionPrice',
  components: {
    VHeadline,
    VContainer,
    // VSlider,
    VLink,
    VButton,
    BitrixPriceForm,
  },
  data() {
    return {
      isForm: false,
    }
  },
  computed: {
currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
  methods: {
    ...mapMutations('forms', {
      setForm: 'SET_ACTIVE_FORM',
    }),

    handleClick: function() {
      this.isForm = !this.isForm
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 375px) {
}

@media (max-width: 411px) {
}

@media (max-width: 768px) {
}
</style>

<style lang="scss" scoped>
.price {
  text-align: center;
  color: white;
}
.price-form {
  max-width: 640px;
  margin: 20px auto 60px;
}

.price-headline {
  margin-top: 25px;
}

.price-subheadline {
  margin: 30px 0;
}

.price-button {
  margin: 20px 0 60px;
}
</style>
